"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var clamp = exports.clamp = function clamp(number, lower, upper) {
    if (number >= upper) {
        return upper;
    }
    if (number <= lower) {
        return lower;
    }
    return number;
};

var range = exports.range = function range(count) {
    return [].concat(_toConsumableArray(new Array(parseInt(count, 10)).keys()));
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/utils.js
// module id = 785
// module chunks = 1